import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";

import {map, startWith} from 'rxjs/operators';
import {fromEvent, Observable} from 'rxjs';

import {AuthenticationService} from "@shared/services/authentication/authentication.service";

import {NewNavigationService} from "@shared/services/new-navigation.service";
import {BaseComponent} from "@shared/components/base-component";
import {SettingsService} from "@shared/services/settings.service";

@Component({
  selector: 'app-select-database',
  templateUrl: './select-database.component.html',
  styleUrls: ['./select-database.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush, //wymagane inaczej błąd  związany z height "NG0100: Expression has changed after it was checked"
})
export class SelectDatabaseComponent extends BaseComponent implements OnInit {

  get timeLeftToChooseDatabase(): number {
    return this._timeLeftToChooseDatabase;
  }
  private _timeLeftToChooseDatabase = 9;

  isLoading = false;
  filtered!: Observable<string[]>;
  allDatabases?: string[];
  height = '';
  databaseCtrl = new FormControl('', Validators.required);

  form = this.formBuilder.group({
    database: this.databaseCtrl
  });

  constructor(
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private navigationService: NewNavigationService,
    private settingsService: SettingsService
  ) {
    super();
    this.allDatabases = this.authenticationService.getDatabases();
  }

  ngOnInit() {
    this.subscribeToDatabaseValueChanges();
    this.databaseCtrl.setValue(this.settingsService.getPreviouslySelectedDatabase());
    this.subscribeToKeyboardEnter();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  onContinue() {
    if (this.isLoading)
      return;

    this.form.markAllAsTouched();

    if (this.form.invalid)
      return;

    this.isLoading = true;
    this.loginWithDatabase();
  }

  private subscribeToDatabaseValueChanges() {
    this.filtered = this.databaseCtrl.valueChanges.pipe(
      startWith(this.settingsService.getPreviouslySelectedDatabase()),
      map(filter => {
        const result = filter ? this.filterItems(filter) : this.allDatabases!.slice();
        this.height = result.length < 4 ? (result.length * 50 + 'px') : '200px';
        return result;
      }));
  }

  private loginWithDatabase() {
    this.authenticationService.authenticateWithDb(this.databaseCtrl.value!)
      .subscribe({
        next: () => this.afterLoginWithDb(),
        error: () => this.isLoading = false
      });
  }

  private afterLoginWithDb() {
    this.settingsService.setPreviouslySelectedDatabase(this.databaseCtrl.value!);
    this.navigationService.toMainPanel();
  }

  private filterItems(filter: string): string[] {
    const filterValue = filter.toLowerCase();
    return this.allDatabases!.filter(option => option.toLowerCase().includes(filterValue));
  }

  private subscribeToKeyboardEnter() {
    this.addToUnsubscribe(fromEvent(document, 'keyup').subscribe(e => {
      const event = e as KeyboardEvent;
      if (event.key === 'Enter') {
        this.onContinue();
      }
    }));
  }
}
